import { User } from '@/store/store'
import Vue from 'vue'

// initial state
const initState = {
  userInfo: null,
  left: 0, // 客服框距离左侧位置
  setShowCompute: false, // 打开计算器
  setShowTel: false, // 左侧小象展开客服电话
}

// getters (state, getters, rootState, rootGetters) => {}
const getters = {}

// actions ({ dispatch, commit, state }, payload) => {}
const actions = {
  // 用于bankey页面的特殊性
  async getUserInfoForBankey({ state, commit }: any, isForce = false) {
    if (!isForce && state.userInfo) return state.userInfo
    try {
      console.log('Vue.prototype.$Http', Vue.prototype.$Http)
      const { data } = await Vue.prototype.$Http.api({
        url: 'webserver/v1/accounts/sys_accountId/getAllInfo',
        method: 'get',
        fail: (res: any) => res,
      })
      console.log('getUserInfo-----', data)
      commit(
        'setUserInfo',
        Object.assign(data, {
          ouid: data.base.ouid,
          ...data.prop.contacts,
          name: data.prop.properties ? data.prop.properties.name : '',
          realnameStatus: data.baseRealname.status,
        })
      )

      return state.userInfo
    } catch (e) {
      console.error('orgAuthList--getUserInfo', e)
    }
  },
  async getUserInfo({ state, commit }: any) {
    try {
      const { data } = await Vue.prototype.$EHttp.api({
        url: 'webserver/v1/accounts/sys_accountId/getAllInfo',
        method: 'get',
      })
      console.log('getUserInfo-----', data)
      commit(
        'setUserInfo',
        Object.assign(data, {
          ouid: data.base.ouid,
          ...data.prop.contacts,
          name: data.prop.properties ? data.prop.properties.name : '',
          realnameStatus: data.baseRealname.status,
        })
      )

      return state.userInfo
    } catch (e) {
      console.error('orgAuthList--getUserInfo', e)

      return Promise.reject(e)
    }
  },
}

// mutations (state, payload) => {}
const mutations = {
  setUserInfo(state: any, payload: any) {
    state.userInfo = payload
  },
  updateRNStatus(state: User, payload: any) {
    state.realname = payload
  },
  setLeft(state: any, payload: string) {
    state.left = payload
  },
  setShowCompute(state: any, payload: boolean) {
    state.setShowCompute = payload
  },
  setShowTel(state: any, payload: boolean) {
    state.setShowTel = payload
  },
}

export default {
  namespaced: true,
  state: initState,
  getters,
  actions,
  mutations,
}
